import { render, staticRenderFns } from "./Productor.vue?vue&type=template&id=50378dcc&scoped=true"
import script from "./Productor.vue?vue&type=script&lang=js"
export * from "./Productor.vue?vue&type=script&lang=js"
import style0 from "./Productor.vue?vue&type=style&index=0&id=50378dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50378dcc",
  null
  
)

export default component.exports